import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AdminWebAppRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/app-routing.module.ts